// assets/collection-grid-mega-menu.js

document.addEventListener('DOMContentLoaded', function() {
  // Desktop Mega-Menü Funktionalität
  initDesktopMegaMenu();
  
  // Mobile Tab Funktionalität
  initMobileTabs();
  
  // Behandle Resize-Events um die korrekte Darstellung zu gewährleisten
  window.addEventListener('resize', function() {
    // Warten, bevor wir Funktionen ausführen (debounce)
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(function() {
      // Stelle sicher, dass Menüs korrekt angezeigt/ausgeblendet werden
      handleMenuDisplayBasedOnScreenSize();
    }, 250);
  });
  
  // Führe initiale Überprüfung durch
  handleMenuDisplayBasedOnScreenSize();
  
  // Behandle Dialog-Öffnungen (für Mobil)
  document.addEventListener('dialog:opened', function(event) {
    if (window.innerWidth < 768) {
      // Stelle sicher, dass Desktop-Menü ausgeblendet ist
      hideDesktopMenu();
      
      // Initialisiere die Tabs
      setTimeout(function() {
        initMobileTabs();
      }, 100);
    }
  });

  // NEUER CODE: Zusätzliche Initialisierung für alle Mega-Menüs
  setTimeout(function() {
    initMegaMenuEvents();
  }, 500);
});

// Behandelt die Anzeige/Ausblendung von Menüs basierend auf Bildschirmgröße
function handleMenuDisplayBasedOnScreenSize() {
  if (window.innerWidth >= 768) {
    // Desktop: Zeige Desktop-Menü, verstecke Mobile-Menü
    enableDesktopMenu();
  } else {
    // Mobil: Verstecke Desktop-Menü, zeige Mobile-Menü
    hideDesktopMenu();
  }
}

// Initialisiert das Desktop Mega-Menü
function initDesktopMegaMenu() {
  const headerItems = document.querySelectorAll('.header__menu-item[data-type="mega_menu"], .header__primary-nav-item');
  
  headerItems.forEach(function(item) {
    // Entferne alte Event-Listener durch Klonen
    const newItem = item.cloneNode(true);
    if (item.parentNode) {
      item.parentNode.replaceChild(newItem, item);
    }
    
    // Hover-Effekt hinzufügen
    newItem.addEventListener('mouseenter', function() {
      if (window.innerWidth < 768) return; // Nur auf Desktop
      
      // Finde Mega-Menü
      let megaMenu = null;
      
      // Suche im Element
      megaMenu = newItem.querySelector('.collection-grid-mega-menu');
      
      // Suche im nächsten Geschwister-Element
      if (!megaMenu && newItem.nextElementSibling) {
        if (newItem.nextElementSibling.classList.contains('collection-grid-mega-menu')) {
          megaMenu = newItem.nextElementSibling;
        }
      }
      
      // Suche im Parent-LI (falls vorhanden)
      if (!megaMenu) {
        const parentLi = newItem.closest('li');
        if (parentLi) {
          megaMenu = parentLi.querySelector('.collection-grid-mega-menu');
        }
      }
      
      // Menü anzeigen wenn gefunden
      if (megaMenu) {
        newItem.setAttribute('aria-expanded', 'true');
        megaMenu.style.visibility = 'visible';
        megaMenu.style.opacity = '1';
        megaMenu.style.display = 'block';
        megaMenu.style.pointerEvents = 'auto';
      }
      
      // Klassen setzen
      newItem.classList.add('is-expanded', 'expanded', 'active', 'hover');
    });
    
    // Leave-Effekt hinzufügen
    newItem.addEventListener('mouseleave', function() {
      if (window.innerWidth < 768) return; // Nur auf Desktop
      
      // Entferne expanded-Zustand
      newItem.setAttribute('aria-expanded', 'false');
      
      // Finde Mega-Menü (gleiche Logik wie oben)
      let megaMenu = null;
      
      megaMenu = newItem.querySelector('.collection-grid-mega-menu');
      
      if (!megaMenu && newItem.nextElementSibling) {
        if (newItem.nextElementSibling.classList.contains('collection-grid-mega-menu')) {
          megaMenu = newItem.nextElementSibling;
        }
      }
      
      if (!megaMenu) {
        const parentLi = newItem.closest('li');
        if (parentLi) {
          megaMenu = parentLi.querySelector('.collection-grid-mega-menu');
        }
      }
      
      // Menü ausblenden wenn gefunden
      if (megaMenu) {
        megaMenu.style.visibility = '';
        megaMenu.style.opacity = '';
        megaMenu.style.display = '';
        megaMenu.style.pointerEvents = '';
      }
      
      // Klassen entfernen
      newItem.classList.remove('is-expanded', 'expanded', 'active', 'hover');
    });
  });
  
  // Auch Parent-LI-Elemente überwachen (falls vorhanden)
  const parentLiElements = document.querySelectorAll('.header__primary-nav-item');
  
  parentLiElements.forEach(function(li) {
    if (!li.hasAttribute('data-menu-fixed')) {
      // Markieren als bearbeitet
      li.setAttribute('data-menu-fixed', 'true');
      
      // Hover-Effekt hinzufügen
      li.addEventListener('mouseenter', function() {
        if (window.innerWidth < 768) return; // Nur auf Desktop
        
        // Finde Mega-Menü
        const megaMenu = li.querySelector('.collection-grid-mega-menu');
        
        // Menü anzeigen wenn gefunden
        if (megaMenu) {
          megaMenu.style.visibility = 'visible';
          megaMenu.style.opacity = '1';
          megaMenu.style.display = 'block';
          megaMenu.style.pointerEvents = 'auto';
        }
        
        // Link-Element markieren
        const menuItem = li.querySelector('.header__menu-item');
        if (menuItem) {
          menuItem.setAttribute('aria-expanded', 'true');
          menuItem.classList.add('is-expanded', 'expanded', 'active', 'hover');
        }
      });
      
      // Leave-Effekt hinzufügen
      li.addEventListener('mouseleave', function() {
        if (window.innerWidth < 768) return; // Nur auf Desktop
        
        // Finde Mega-Menü
        const megaMenu = li.querySelector('.collection-grid-mega-menu');
        
        // Menü ausblenden wenn gefunden
        if (megaMenu) {
          megaMenu.style.visibility = '';
          megaMenu.style.opacity = '';
          megaMenu.style.display = '';
          megaMenu.style.pointerEvents = '';
        }
        
        // Link-Element zurücksetzen
        const menuItem = li.querySelector('.header__menu-item');
        if (menuItem) {
          menuItem.setAttribute('aria-expanded', 'false');
          menuItem.classList.remove('is-expanded', 'expanded', 'active', 'hover');
        }
      });
    }
  });
}

// Aktiviert das Desktop-Menü
function enableDesktopMenu() {
  // Desktop-Menü Elemente
  const desktopMenus = document.querySelectorAll('.collection-grid-mega-menu');
  desktopMenus.forEach(function(menu) {
    menu.style.display = '';
    menu.style.visibility = '';
    menu.style.opacity = '';
    menu.style.height = '';
    menu.style.overflow = '';
  });
  
  // Desktop-Menü Container
  const desktopMenuContainers = document.querySelectorAll('.header__primary-nav, .header__menu, .header__menu-item');
  desktopMenuContainers.forEach(function(container) {
    container.style.display = '';
    container.style.visibility = '';
    container.style.opacity = '';
  });
}

// Versteckt das Desktop-Menü (für Mobile)
function hideDesktopMenu() {
  const desktopMenus = document.querySelectorAll('.collection-grid-mega-menu, .header-sidebar__desktop-only, .header-sidebar__collapsible-panel');
  desktopMenus.forEach(function(menu) {
    menu.style.display = 'none';
    menu.style.visibility = 'hidden';
    menu.style.opacity = '0';
    menu.style.height = '0';
    menu.style.overflow = 'hidden';
  });
}

// Initialisiert die mobile Menü-Tabs
function initMobileTabs() {
  // Finde die Tab-Container
  const tabsContainers = document.querySelectorAll('.mobile-menu-tabs');
  
  if (tabsContainers.length === 0) return;
  
  tabsContainers.forEach(function(container) {
    // Stelle sicher, dass der Container vertikal ist
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    
    // Finde alle Tabs im Container
    const tabs = container.querySelectorAll('.mobile-menu-tab');
    
    // Wenn keine aktiven Tabs gefunden wurden, aktiviere den ersten
    if (container.querySelector('.mobile-menu-tab--active') === null && tabs.length > 0) {
      tabs[0].classList.add('mobile-menu-tab--active');
      
      // Erstes Panel aktivieren
      const firstPanelId = tabs[0].getAttribute('data-target');
      if (firstPanelId) {
        const firstPanel = document.getElementById(firstPanelId);
        if (firstPanel) {
          firstPanel.classList.add('mobile-menu-panel--active');
        }
      }
    }
    
    tabs.forEach(function(tab) {
      // Stelle sicher, dass Tabs korrekt formatiert sind
      tab.style.display = 'block';
      tab.style.width = '100%';
      tab.style.textAlign = 'left';
      tab.style.padding = '15px';
      tab.style.color = '#fff';
      tab.style.borderBottom = '1px solid rgba(255, 255, 255, 0.1)';
      
      // Wenn es der aktive Tab ist, spezielle Styling hinzufügen
      if (tab.classList.contains('mobile-menu-tab--active')) {
        tab.style.borderLeft = '3px solid #fff';
        tab.style.paddingLeft = '12px';
      }
      
      // Tab-Klick behandeln
      tab.addEventListener('click', function() {
        // Target-Panel ID
        const targetId = this.getAttribute('data-target');
        if (!targetId) return;
        
        // Entferne Aktiv-Status von allen Tabs
        tabs.forEach(function(t) {
          t.classList.remove('mobile-menu-tab--active');
          t.style.borderLeft = 'none';
          t.style.paddingLeft = '15px';
        });
        
        // Markiere diesen Tab als aktiv
        this.classList.add('mobile-menu-tab--active');
        this.style.borderLeft = '3px solid #fff';
        this.style.paddingLeft = '12px';
        
        // Blende alle Panels aus
        const panels = document.querySelectorAll('.mobile-menu-panel');
        panels.forEach(function(panel) {
          panel.classList.remove('mobile-menu-panel--active');
          panel.style.display = 'none';
        });
        
        // Zeige das Target-Panel
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
          targetPanel.classList.add('mobile-menu-panel--active');
          targetPanel.style.display = 'block';
        }
      });
    });
  });
  
  // Stelle sicher, dass die Panel-Darstellung korrekt ist
  const panels = document.querySelectorAll('.mobile-menu-panel');
  panels.forEach(function(panel) {
    if (panel.classList.contains('mobile-menu-panel--active')) {
      panel.style.display = 'block';
    } else {
      panel.style.display = 'none';
    }
  });
}

// NEUE FUNKTION: Initialisiert Hover-Events für alle Mega-Menüs
function initMegaMenuEvents() {
  console.log("Initialisiere Hover-Events für alle Mega-Menüs");
  
  // Finde alle Mega-Menü-Disclosures im Header
  const megaMenuDisclosures = document.querySelectorAll('mega-menu-disclosure');
  
  // Keine Mega-Menüs gefunden, also früh aussteigen
  if (megaMenuDisclosures.length === 0) return;
  
  console.log(`${megaMenuDisclosures.length} Mega-Menüs gefunden`);
  
  megaMenuDisclosures.forEach(function(disclosure) {
    // Finde Details und Summary Elemente
    const details = disclosure.querySelector('details');
    if (!details) return;
    
    const summary = details.querySelector('summary');
    if (!summary) return;
    
    // Finde das Mega-Menü
    const megaMenu = details.querySelector('.collection-grid-mega-menu');
    if (!megaMenu) return;
    
    const title = summary.textContent.trim();
    console.log(`Initialisiere Mega-Menü für: ${title}`);
    
    // Markieren für spätere Referenz
    details.setAttribute('data-has-mega-menu', 'true');
    
    // Fix für Details-Element-Verhalten
    function stopDetailsPropagation(e) {
      if (details.hasAttribute('open') && !details.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    
    // Event-Listener für Details und Summary
    summary.addEventListener('mouseenter', function() {
      if (window.innerWidth < 768) return; // Nur auf Desktop
      
      console.log(`Maus über ${title}`);
      details.setAttribute('open', 'true');
      
      // Mega-Menü anzeigen
      megaMenu.style.display = 'block';
      megaMenu.style.visibility = 'visible';
      megaMenu.style.opacity = '1';
      megaMenu.style.pointerEvents = 'auto';
      
      // Verhindere, dass sich Details automatisch schließt
      document.addEventListener('click', stopDetailsPropagation, true);
    });
    
    // MouseLeave für Details
    details.addEventListener('mouseleave', function() {
      if (window.innerWidth < 768) return; // Nur auf Desktop
      
      // Verzögerung, um zu prüfen, ob Mauszeiger immer noch über dem Menü ist
      setTimeout(function() {
        if (!megaMenu.matches(':hover') && !summary.matches(':hover')) {
          console.log(`Maus verlässt ${title}`);
          details.removeAttribute('open');
          megaMenu.style.display = '';
          megaMenu.style.visibility = '';
          megaMenu.style.opacity = '';
          megaMenu.style.pointerEvents = '';
          
          // Event-Listener entfernen
          document.removeEventListener('click', stopDetailsPropagation, true);
        }
      }, 50);
    });
    
    // MouseLeave für Mega-Menü
    megaMenu.addEventListener('mouseleave', function() {
      if (window.innerWidth < 768) return; // Nur auf Desktop
      
      console.log(`Mega-Menü verlassen für ${title}`);
      details.removeAttribute('open');
      megaMenu.style.display = '';
      megaMenu.style.visibility = '';
      megaMenu.style.opacity = '';
      megaMenu.style.pointerEvents = '';
      
      // Event-Listener entfernen
      document.removeEventListener('click', stopDetailsPropagation, true);
    });
  });
}